<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <!--轮播图-->
    <div class="swiper-con border-box">
      <Swiper :banners="banners" :type="'view'"></Swiper>
    </div>

    <!--城市信息-->
    <div class="city-info city-info1">
      <div class="city-title">
        <h3>{{cityinfo.name}}</h3>
      </div>
      <div class="city-desc" v-html="cityinfo.info"></div>
    </div>

    <div v-for="(item,index) in root" :key="index">
      <div class="split-line h13"></div>
      <div class="city-info">
        <div class="city-title clearfix">
          <h3>{{item.info}}</h3>
          <div class="city-voice" @click="playVoice(index)">
            <audio :id="'Audio'+index" style="overflow: hidden" :src="item.url"></audio>
            <img src="../../assets/icon_32.png" alt="">
            <p :id="'slider'+index">
              <b>{{item.resTime|initTime}}</b>
              <span :style="{width:item.currSlider}"></span>
            </p>
          </div>
        </div>
        <div class="city-desc" v-html="item.content"></div>
      </div>
    </div>

    <!--新增附近推荐景区-->
    <div class="conference-list p024 half clearfix mt26" v-if="near&&near.length>0">
      <div class="split-line h13"></div>
      <div class="list-tit">附近推荐景区
        <router-link class="list-more" v-if="near&&near.length>0" :to="{path:'/view-list',query:{siteid:'',sort:1,lat:'',lng:'',TimeStamp:TimeStamp,inputValue:'',appKey:appKeyA}}">查看更多</router-link>
      </div>
      <div>
        <div class="conference-item-parent border-box" @click="toViewDetail(item.id)"  v-for="(item,index) in near" v-if="index<4">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <div class="conference-item-info clearfix">
              <div class="label-box">
                <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
              </div>
              <div class="right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-view.png" alt="">
                  <span class="icon-time">{{item.spotnum}}个讲解点</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>
  import Swiper from '../../components/Swiper'
  import P400 from '../../components/P400'
  import {getCardinfo,getHome} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import {wxGetPosition,wxShareme,} from '@/utils/wechat'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        citycode: this.$route.query.citycode || "", //区域代码
        cityinfo: {},
        root: [],
        near: [],//附近推荐
        banners: {}, //banner图片
        userInfo: {}, //用户信息

        lastIndex: 0, //上一次播放的音频下标
        videoTimer: null, //播放音频计时器

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: '',

        P400: 0, //系统维护中
      }
    },
    computed: {

    },
    beforeDestroy(){
      if(this.videoTimer){
        clearInterval(this.videoTimer);
      }
    },
    created() {
      this.global.set_glabalClear();
      this.siteid = getStore("siteid") || "";
      this.sregion = getStore("sregion") || "";
      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.userInfo = getStore("userInfo");

      this.initData();
      this.getViewList();
    },
    methods: {
      async initData(){
        this.userInfo = getStore("userInfo");

        let res = await getCardinfo({
          TimeStamp: this.TimeStamp,
          citycode: this.citycode
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.banners = res.data.bannerinfo;
          this.cityinfo = res.data.total;
          for(var i=0; i<res.data.root.length; i++){
            res.data.root[i].resTime = res.data.root[i].totaltime;
            res.data.root[i].currSlider = 0;
          }
          this.root = res.data.root;

          let title = '金牌解说 | 城市名片';
          let desc = '我在“金牌解说”听'+ this.cityinfo.name +'的历史故事';
          let img = this.banners[0].img;
          let link = 'city-card?citycode='+ this.citycode +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          wxShareme(title,desc,img,link);

          this.$route.meta.title = this.cityinfo.name;


        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
//          this.$router.push({
//            path: `/400?${'appKey=' + this.appKey}`
//          });
        }

      },

      async getViewList(){
        let res = await getHome({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.citycode,
          page: 1,
          rows: 4,
          type: 1, //0:热门 1:距离排序
          onlyshop: 1, //1:需要景区数据
          onlybag: 0, //1:需要导游数据
          name: "", //搜索关键词
          cid: "", //导游筛选
          openid: this.userInfo.openid,
          sregion: this.sregion
        });
        if (res.errcode === '00000') {
          this.$loading.hide();
          this.near = res.data.root
        }
      },

      toViewDetail(id){
        this.$router.push({
          path: `/view-detail?${'shopid='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //播放音频
      playVoice(index){
        var self = this;
        self.$nextTick(function() {
          var voice = document.getElementById('Audio'+index);
          if(self.lastIndex != index){
            var lastVoice = document.getElementById('Audio'+self.lastIndex);
            self.lastIndex = index;
            lastVoice.pause();
            voice.play();
            self.TimeSpan(voice,index)
          }else {
            if (voice.paused) {
              voice.play();
              self.TimeSpan(voice,index)
            } else {
              voice.pause();
              if(self.videoTimer != null){
                clearInterval(self.videoTimer);
              }
            }
          }
        })
      },

      //  实时监听音频播放进度
      TimeSpan(voice,index){
        var self = this;
        if(voice.readyState != 4){
          self.$loading.show('音频加载中');
        }
        if(self.videoTimer != null){
          clearInterval(self.videoTimer);
        }
        self.videoTimer = setInterval(function () {
          if(voice.currentTime > 0){
            self.$loading.hide();
          }
          var totaltime = self.root[index].totaltime;
          var rtime = parseInt(totaltime - voice.currentTime);//获取剩余时间
          if(rtime != undefined && !isNaN(rtime)){
            var slider = document.getElementById('slider'+index);
            self.root[index].resTime = rtime;
            self.root[index].currSlider = (voice.currentTime / self.root[index].totaltime) * slider.offsetWidth + "px";
          }
        }, 1000);

        voice.onended = function() {  //音频播放结束
          clearInterval(self.videoTimer);
          self.root[index].resTime = self.root[index].totaltime;
          self.root[index].currSlider = 0;
        };
      },

    },
    components: {
      Swiper,
      P400,
    },
    //格式化数据
    filters: {
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    },

  }

</script>

<style scoped>
  /*轮播图*/
  .swiper-con{width:100%;height: 3.85rem;}
  .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}

  .city-info{padding: .24rem;}
  .city-title{ height: .48rem; }
  .city-title h3{ float: left;line-height: .48rem;font-size: .3rem;color: #010101;}
  .city-desc{margin-top:.18rem;line-height: .34rem;font-size: .26rem;color: #555; }
  .city-desc *{line-height: .34rem!important;font-size: .26rem!important;color: #555!important; }
  .city-info1{position: relative;background:#fff;border-radius:.3rem .3rem 0 0;margin-top:-.3rem;z-index: 1;}
  .city-info1 .city-title h3{font-size: .38rem;}
  .city-voice{position: relative; float: right; padding-left: .38rem; width: 1.05rem;height: .48rem; }
  .city-voice img{ position: absolute;left: 0;top: .08rem;width: .31rem;height: .31rem; }
  .city-voice p{ position: absolute;left: .38rem; top: .3rem; width: 1.05rem; height: .04rem; background-color: #c2e3ff; border-radius: .04rem;  }
  .city-voice p span{ position: absolute; left: 0; bottom: 0; height: .04rem; background-color: #0088fb; border-radius: .04rem;  }
  .city-voice p b{ position: absolute; left: 0; top: -.24rem; font-size: .18rem;color: #0088fb; }

  /*附近景区*/
  .list-tit{padding:.2rem 0;height:.36rem;color:#333;font-weight:bold;font-size:.32rem;line-height:.36rem}
  .list-tit span{float:left;margin-right:.12rem;width:.07rem;height:.36rem;background-color:#faaf39}
  .list-more{float:right;padding:0 .07rem;color:#555;font-size:.24rem}
  .conference-item-info-label img{width:.17rem;height:.26rem;vertical-align: middle;}
  .half .conference-item-parent{float: left;width:50%;}
  .half .conference-item-parent .conference-item{position: relative;margin-top: .2rem;background-color: #fff;border-radius: .15rem;}
  .half .conference-item-parent:nth-of-type(odd) .conference-item{padding-right:3%;}
  .half .conference-item-parent:nth-of-type(even) .conference-item{padding-left:3%;}
  .half .conference-item-parent .conference-item-img{position:relative;width:100%;height:2.7rem; border-radius: .08rem .08rem 0 0;overflow: hidden;}
  .half .conference-item-parent .conference-item-info{height:1rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .half .conference-item-parent .conference-item-title{font-weight: bold;color: #333;font-size:.26rem;}
  .half .conference-item-parent .label-box{width: 100%;height:.48rem; line-height: .48rem; padding-top: .08rem; }
  .half .conference-item-parent .right-info{width: 100%;text-align: left;}
  .half .conference-item-parent .icon-time {font-size: .22rem;margin-left: .07rem;font-weight: bold;color: #666;}
</style>



// WEBPACK FOOTER //
// src/page/city-card/city-card.vue